export class DocumentConfigModel {
  id: number;
  active: boolean;
  required: boolean;
  itemTypeID: Number;
  facilityTypeID: Number;
  documentReferenceID: number;
  applicationCategoryID: number;
  changeTypeRefID: number;
  facilityCategoryID: number;
  mLevelID: number;
  mRLevelID: number;
}

export class DocumentModel {
  id: number;
  name: string;
  description: string;
  plcDocument: boolean;
  focalPersonDocument: boolean;
}
